import { weekdayOf } from '@/utils/brockenUnits'

export type GanztagPlanEntry = {
  teacherId: string
  rank: number
  teacherName: string
  teacherCode?: string
}

export type GanztagPlanBlock = {
  id: string
  blockName: string | null
  timeSlotIds: string[]
  entries: GanztagPlanEntry[]
}

export type GanztagPlanDay = {
  date: string
  lessonCount: number
  teacherCount: number
  blocks: GanztagPlanBlock[]
}

export type GanztagWeekdaySeries = {
  weekday: number
  dates: GanztagPlanDay[]
}

export function groupGanztagWeekdays(days: GanztagPlanDay[]): GanztagWeekdaySeries[] {
  const map = new Map<number, GanztagPlanDay[]>()
  const order: number[] = []
  for (const day of days) {
    if (!day.date) continue
    const wd = weekdayOf(day.date)
    let list = map.get(wd)
    if (!list) {
      list = []
      map.set(wd, list)
      order.push(wd)
    }
    list.push(day)
  }
  return order.map(weekday => ({
    weekday,
    dates: (map.get(weekday) ?? []).slice().sort((a, b) => a.date.localeCompare(b.date)),
  }))
}
